import {
  Table,
  TableBody,
  TableCell,
  TableFooter,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table"
import { format } from "date-fns"
import { TokenIcon } from "@/components/token"
import { Badge } from "@/components/ui/badge"
import NetworkIcon from "@/components/icons/network"
import Loader from "@/components/layout/loader"
import { WithdrawalStatus, useWithdrawals } from "@/api/withdrawals"
import { getAccountNumber } from "@/api/bank-accounts"
import OptionsDropdownMenu from "@/components/ux/options.dropdown-menu"
import { DropdownMenuItem } from "@/components/ui/dropdown-menu"
import NoteTextLineIcon from "@/components/icons/note-text-line"
import { useNavigate } from "react-router-dom"

const TABLE_COLUMNS = 5

const badgeVariant = {
  [WithdrawalStatus.PENDING]: "yellow",
  [WithdrawalStatus.COMPLETED]: "green",
  [WithdrawalStatus.FAILED]: "destructive",
}

export default function WithdrawalsTable() {
  const { withdrawals, size, setSize, hasMore } = useWithdrawals({})
  const navigate = useNavigate()

  if (!withdrawals) {
    return <Loader message="Loading withdrawals..." />
  }

  return (
    <Table>
      <TableHeader>
        <TableRow className="rounded-t-md">
          <TableHead className="pl-6">Date</TableHead>
          <TableHead>Amount</TableHead>
          <TableHead>Network</TableHead>
          <TableHead className="hidden sm:table-cell">Bank Account</TableHead>
          <TableHead>Status</TableHead>
          <TableHead></TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {withdrawals.map((withdrawal) => (
          <TableRow key={withdrawal.id}>
            <TableCell className="pl-6">
              {format(new Date(withdrawal.createdAt), "MMM do, yyyy")}
            </TableCell>
            <TableCell>
              <div className="flex flex-row gap-2 items-center">
                {withdrawal.token && <TokenIcon name={withdrawal.token} />}
                <div>
                  {withdrawal.amount} {withdrawal.token}
                </div>
              </div>
            </TableCell>
            <TableCell>
              <Badge
                variant="secondary"
                className="flex flex-row gap-2 font-normal text-sm w-fit"
              >
                <div className="w-4 h-4">
                  <NetworkIcon name={withdrawal.network} />
                </div>
                {withdrawal.network.substring(0, 3)}
              </Badge>
            </TableCell>
            <TableCell>
              {withdrawal.bankAccount.bankName} -{" "}
              {getAccountNumber(withdrawal.bankAccount)}
            </TableCell>
            <TableCell>
              <Badge variant={badgeVariant[withdrawal.status as WithdrawalStatus] as "yellow" | "green" | "destructive"}>
                {withdrawal.status}
              </Badge>
            </TableCell>
            <TableCell>
              <OptionsDropdownMenu>
                <DropdownMenuItem
                  onClick={() => navigate(`/balances/${withdrawal.id}`)}
                >
                  <NoteTextLineIcon />
                  Details
                </DropdownMenuItem>
              </OptionsDropdownMenu>
            </TableCell>
          </TableRow>
        ))}
        {withdrawals.length === 0 && (
          <TableRow>
            <TableCell
              colSpan={TABLE_COLUMNS}
              className="text-center text-gray-300"
            >
              No withdrawals found
            </TableCell>
          </TableRow>
        )}
      </TableBody>
      {hasMore && (
        <TableFooter>
          <TableRow>
            <TableCell colSpan={TABLE_COLUMNS}>
              <button
                onClick={() => setSize(size + 1)}
                className="flex flex-col w-full items-center bg-white p-3 text-center"
              >
                Load more...
              </button>
            </TableCell>
          </TableRow>
        </TableFooter>
      )}
    </Table>
  )
}
